const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotarinIconVorsorge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 587",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-671.875,-1313.41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,671.875,1303.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Krankenzimmer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,274.835L300,405.04L197.841,405.04L197.841,274.835L300,274.835ZM283.096,291.739L214.745,291.739L214.745,388.136L283.096,388.136L283.096,291.739Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,405.04L0,405.04L0,300L197.841,300L197.841,274.835L300,274.835L300,284.791L526.375,284.791L526.375,300L600,300L600,405.04ZM509.555,301.695L300,301.695C293.141,301.695 287.236,297.609 284.586,291.739L214.745,291.739L214.745,300C214.745,309.336 207.177,316.904 197.841,316.904C197.841,316.904 64.778,316.904 16.904,316.904L16.904,388.136L583.096,388.136L583.096,316.904L526.375,316.904C517.611,316.904 510.405,310.235 509.555,301.695Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22595,0,0,0.909677,-135.568,15.5473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600,219.369L600,329.591L559.086,329.591L559.086,219.369L600,219.369ZM586.212,237.951C586.212,237.951 572.874,237.951 572.874,237.951L572.874,311.009C572.874,311.009 586.212,311.009 586.212,311.009L586.212,237.951Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22595,0,0,0.909677,-685.409,15.5473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600,219.369L600,329.591L559.086,329.591L559.086,219.369L600,219.369ZM586.212,237.951C586.212,237.951 572.874,237.951 572.874,237.951L572.874,311.009C572.874,311.009 586.212,311.009 586.212,311.009L586.212,237.951Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01569,0,0,1.42389,-9.02233,-188.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.921,405.04L574.921,441.946L33.575,441.946L33.575,405.04L574.921,405.04ZM558.278,416.911L50.217,416.911C50.217,416.911 50.217,430.075 50.217,430.075L558.278,430.075L558.278,416.911Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M277.243,432.524L407.663,525.652",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.114,563.309L197.282,432.524",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20332,0,0,1.20332,-214.892,-86.7129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.689,503.916C538.183,503.916 552.385,518.119 552.385,535.613C552.385,553.106 538.183,567.309 520.689,567.309C503.196,567.309 488.993,553.106 488.993,535.613C488.993,518.119 503.196,503.916 520.689,503.916ZM520.689,517.964C510.949,517.964 503.041,525.872 503.041,535.613C503.041,545.353 510.949,553.261 520.689,553.261C530.43,553.261 538.338,545.353 538.338,535.613C538.338,525.872 530.43,517.964 520.689,517.964Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,599.085,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.243,432.524L407.663,525.652",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.114,563.309L197.282,432.524",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20332,0,0,1.20332,-214.892,-86.7129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.689,503.916C503.196,503.916 488.993,518.119 488.993,535.613C488.993,553.106 503.196,567.309 520.689,567.309C538.183,567.309 552.385,553.106 552.385,535.613C552.385,518.119 538.183,503.916 520.689,503.916ZM520.689,517.964C530.43,517.964 538.338,525.872 538.338,535.613C538.338,545.353 530.43,553.261 520.689,553.261C510.949,553.261 503.041,545.353 503.041,535.613C503.041,525.872 510.949,517.964 520.689,517.964Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.38461,0,0,1.07994,-36.6535,-0.766675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.241,9.591L108.241,257.769L71.264,257.769L71.264,9.591L108.241,9.591ZM96.033,25.244L83.472,25.244L83.472,242.116L96.033,242.116L96.033,25.244Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.08763,0,0,1,-7.52036,15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.086,245.68L175.086,300L37.13,300L37.13,245.68L175.086,245.68ZM159.544,262.584L52.672,262.584L52.672,283.096L159.544,283.096L159.544,262.584Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07547,0,0,1.08397,-30.549,-23.9151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.841,284.791L517.841,395.724L291.708,395.724L291.708,284.791L517.841,284.791ZM502.124,300.385C502.124,300.385 307.426,300.385 307.426,300.385C307.426,300.385 307.426,380.13 307.426,380.13L502.124,380.13L502.124,300.385Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.744,43.426L187.423,43.426",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.167,29.204L170.167,68.457",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.167,185.804L170.167,220.351",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35043,0,0,1.07944,-58.1092,-4.85071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.162,61.062L203.162,182.804L136.602,182.804L136.602,61.062L203.162,61.062ZM190.645,76.722L149.12,76.722L149.12,167.144L190.645,167.144L190.645,76.722Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.758,108.28L204.869,108.28",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotarinIconVorsorge);
export default __webpack_public_path__ + "static/media/Notarin_Icon_Vorsorge.a8b8fee2a5274e322ffb75bc4f3067a1.svg";
export { ForwardRef as ReactComponent };